export const GLOBAL_SETTING_KEYS = new Set<string>([])
